// extracted by mini-css-extract-plugin
module.exports = {"confirm_address":"ContractSavingsPersonalInformationProofOfAddressAllianz_confirm_address_1xiN5"};